export const GLOBAL_BORDER_RADIUS = 10 as const // [px]
export const BUTTON_BORDER_RADIUS = 5 as const // [px]
export const TOOLBAR_HEIGHT = 65 as const // [px]
export const CONTAINER_SPACING = 3 as const // [px]
export const DISABLED_CONTAINER_OPACITY = 0.4 as const // [%]
